import DatePicker from 'components/atoms/input/types/datePicker';
import PropTypes from 'prop-types';

const DateInput = ({ id, title, setValue, values, isRequired }) => (
  <div className="input-wrapper">
    <label htmlFor={id}>
      {title} {isRequired && <span className="color-red">*</span>}
    </label>
    <DatePicker
      valueChanged={(e) => {
        setValue({
          [id]: e,
        });
      }}
      value={values[id] || ''}
    />
  </div>
);

DateInput.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  setValue: PropTypes.func,
  isRequired: PropTypes.bool,
  values: PropTypes.shape(),
};

export default DateInput;
